export const getUnorderedListColumns = (isMobile: boolean, isTabletPortait: boolean) => {
    if (isMobile) {
        return 1;
    } else if (isTabletPortait) {
        return 2;
    } else {
        return 3;
    }
};
